"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FiltersMenu = _interopRequireDefault(require("./FiltersMenu"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _PillContainer = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/PillContainer"));

var _Pill = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/Pill"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OverviewFilters = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OverviewFilters, _Component);

  var _super = _createSuper(OverviewFilters);

  function OverviewFilters() {
    var _this;

    (0, _classCallCheck2.default)(this, OverviewFilters);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      areFiltersOpen: false,
      areFiltersOpenFromFilterPill: false,
      areFiltersOpenFromMain: false,
      areAppliedFiltersVisible: !_this.props.areAppliedFiltersHiddenByDefault,
      selectedFilter: undefined,
      filters: _this.props.filters.filter(function (filter) {
        return filter.type === 'filter';
      })
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var _this$state = _this.state,
          areFiltersOpen = _this$state.areFiltersOpen,
          areFiltersOpenFromFilterPill = _this$state.areFiltersOpenFromFilterPill,
          areFiltersOpenFromMain = _this$state.areFiltersOpenFromMain;

      if (areFiltersOpen || areFiltersOpenFromFilterPill || areFiltersOpenFromMain) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.setState({
          areFiltersOpenFromFilterPill: false,
          areFiltersOpenFromMain: false,
          areFiltersOpen: false
        }, _this.removeHandler);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDropdownToggle", function () {
      _this.setState(function (_ref) {
        var areFiltersOpen = _ref.areFiltersOpen,
            areFiltersOpenFromFilterPill = _ref.areFiltersOpenFromFilterPill,
            areFiltersOpenFromMain = _ref.areFiltersOpenFromMain;
        return {
          areFiltersOpen: !areFiltersOpen,
          areFiltersOpenFromFilterPill: areFiltersOpen && areFiltersOpenFromFilterPill,
          areFiltersOpenFromMain: areFiltersOpen && areFiltersOpenFromMain,
          selectedFilter: undefined
        };
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleAppliedFiltersVisibility", function () {
      _this.setState(function (_ref2) {
        var areAppliedFiltersVisible = _ref2.areAppliedFiltersVisible;
        return {
          areAppliedFiltersVisible: !areAppliedFiltersVisible
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoad", function (filterId, items) {
      _this.setState(function (_ref3) {
        var filters = _ref3.filters;
        var filterIndex = filters.findIndex(function (filter) {
          return filter.id === filterId;
        });

        var updatedFilter = _objectSpread(_objectSpread({}, filters[filterIndex]), {}, {
          items: items
        });

        return {
          filters: [].concat((0, _toConsumableArray2.default)(filters.slice(0, filterIndex)), [updatedFilter], (0, _toConsumableArray2.default)(filters.slice(filterIndex + 1)))
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onApplyFilters", function (id, data) {
      _this.props.onFilterChange(id, data);

      _this.onCancelFilters();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancelFilters", function () {
      _this.setState({
        areFiltersOpen: false,
        areFiltersOpenFromFilterPill: false,
        areFiltersOpenFromMain: false,
        selectedFilter: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearFilterCriteria", function () {
      _this.props.onClearFilterCriteria();
    });
    return _this;
  }

  (0, _createClass2.default)(OverviewFilters, [{
    key: "getDisplayAppliedFilters",
    value: function getDisplayAppliedFilters() {
      var filters = this.state.filters;
      var defaultFiltersList = filters.map(function (filter) {
        return filter.id;
      });
      var appliedFilters = this.props.appliedFilters;
      if (!appliedFilters) return [];
      return Object.keys(appliedFilters).filter(function (key) {
        // ignore search
        if (key === 'search' || !defaultFiltersList.includes(key)) {
          return false;
        }

        var value = appliedFilters[key]; // ignore empty arrays

        if (Array.isArray(value) && !value.length) {
          return false;
        }

        return value === false || !!value;
      }).map(function (key) {
        var _appliedFilters$key, _filter$items;

        var filter = filters.find(function (filter) {
          return filter.id === key;
        });
        var values = (_appliedFilters$key = appliedFilters[key]) !== null && _appliedFilters$key !== void 0 ? _appliedFilters$key : [];
        var filterItems = (_filter$items = filter.items) !== null && _filter$items !== void 0 ? _filter$items : [];

        if (key === 'moderationLabel') {
          values = values.filter(function (value) {
            return filterItems.some(function (item) {
              return item.value === value;
            });
          });
        }

        return {
          filter: key,
          name: filter.name,
          pillValue: filter.getPillDisplayValue(values)
        };
      });
    }
  }, {
    key: "getFiltersMenu",
    value: function getFiltersMenu() {
      var _this2 = this;

      var _this$state2 = this.state,
          areFiltersOpenFromFilterPill = _this$state2.areFiltersOpenFromFilterPill,
          selectedFilter = _this$state2.selectedFilter;
      var _this$props = this.props,
          appliedFilters = _this$props.appliedFilters,
          filters = _this$props.filters;
      return (0, _preact.h)(_FiltersMenu.default, {
        areFiltersOpenFromFilterPill: areFiltersOpenFromFilterPill,
        selectedFilter: selectedFilter,
        appliedFilters: appliedFilters,
        filters: filters,
        onFilterClick: function onFilterClick(filterId) {
          return _this2.setState({
            selectedFilter: filterId
          });
        },
        onFilterBack: function onFilterBack() {
          return _this2.setState({
            selectedFilter: undefined
          });
        },
        onApplyFilters: this.onApplyFilters,
        onCancelFilters: this.onCancelFilters,
        onLoad: this.onLoad
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          filters = _this$props2.filters,
          appliedFilters = _this$props2.appliedFilters,
          onFilterChange = _this$props2.onFilterChange,
          withSearch = _this$props2.withSearch,
          searchPlaceholder = _this$props2.searchPlaceholder,
          _this$props2$label = _this$props2.label,
          label = _this$props2$label === void 0 ? 'Filters' : _this$props2$label,
          _this$props2$hideBtnL = _this$props2.hideBtnLabel,
          hideBtnLabel = _this$props2$hideBtnL === void 0 ? 'Hide filters' : _this$props2$hideBtnL,
          _this$props2$clearFil = _this$props2.clearFiltersLabel,
          clearFiltersLabel = _this$props2$clearFil === void 0 ? 'Clear all' : _this$props2$clearFil,
          dataElementName = _this$props2.dataElementName,
          dataTrackType = _this$props2.dataTrackType;
      var _this$state3 = this.state,
          areAppliedFiltersVisible = _this$state3.areAppliedFiltersVisible,
          selectedFilter = _this$state3.selectedFilter,
          areFiltersOpen = _this$state3.areFiltersOpen,
          areFiltersOpenFromFilterPill = _this$state3.areFiltersOpenFromFilterPill,
          areFiltersOpenFromMain = _this$state3.areFiltersOpenFromMain;
      var displayAppliedFilters = this.getDisplayAppliedFilters();
      var areFiltersApplied = displayAppliedFilters.length > 0;
      var mainFilters = filters.filter(function (filter) {
        return filter.type === 'filter' && filter.isMain;
      });
      return (0, _preact.h)("div", {
        ref: function ref(node) {
          _this3.wrapperRef = node;
        }
      }, (0, _preact.h)("div", {
        className: "overview__filters-container"
      }, mainFilters.map(function (mainFilter) {
        return (0, _preact.h)("div", {
          key: mainFilter.id
        }, (0, _preact.h)(_Button.default, {
          key: mainFilter.id,
          title: mainFilter.name,
          size: "medium",
          className: "overview__filters-container-open-button qa-overview-open-filters",
          onClick: function onClick() {
            return _this3.setState({
              areFiltersOpen: false,
              areFiltersOpenFromFilterPill: false,
              areFiltersOpenFromMain: !areFiltersOpenFromMain,
              selectedFilter: mainFilter.id
            }, _this3.addHandler);
          },
          "data-track-type": dataTrackType,
          "data-element-name": dataElementName ? "".concat(dataElementName, " filter ").concat(mainFilter.id, " button") : undefined
        }), areFiltersOpenFromMain && selectedFilter === mainFilter.id && (0, _preact.h)("div", {
          className: "overview__filters-box-container"
        }, (0, _preact.h)("div", {
          className: "overview__filters-box"
        }, _this3.getFiltersMenu())));
      }), filters.length > 0 && (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
        title: (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
          icon: "filter",
          height: 12,
          width: 12
        }), label),
        size: "medium",
        className: "overview__filters-container-open-button qa-overview-open-filters",
        onClick: this.handleDropdownToggle,
        "data-track-type": dataTrackType,
        "data-element-name": dataElementName ? "".concat(dataElementName, " filter button") : undefined
      }), areFiltersOpen && (0, _preact.h)("div", {
        className: "overview__filters-box-container"
      }, (0, _preact.h)("div", {
        className: "overview__filters-box"
      }, this.getFiltersMenu()))), withSearch && (0, _preact.h)(_SearchBox.default, {
        placeholder: searchPlaceholder,
        value: appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.search,
        onSubmit: /*#__PURE__*/function () {
          var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return onFilterChange('search', value);

                  case 2:
                    return _context.abrupt("return", _context.sent);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        onClear: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onFilterChange('search', '');

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })),
        isModerationOverview: true
      }), !areAppliedFiltersVisible && !!(displayAppliedFilters !== null && displayAppliedFilters !== void 0 && displayAppliedFilters.length) && (0, _preact.h)(_Button.default, {
        outlined: true,
        size: "medium",
        title: "".concat(displayAppliedFilters === null || displayAppliedFilters === void 0 ? void 0 : displayAppliedFilters.length, " Hidden filter").concat(displayAppliedFilters.length > 1 ? 's' : ''),
        variant: "brand",
        className: "qa-overview-hide-filters",
        onClick: this.toggleAppliedFiltersVisibility,
        "data-track-type": dataTrackType,
        "data-element-name": dataElementName ? "".concat(dataElementName, " hidden filter button") : undefined
      })), areAppliedFiltersVisible && areFiltersApplied && (0, _preact.h)(_PillContainer.default, null, displayAppliedFilters.map(function (_ref6) {
        var filter = _ref6.filter,
            name = _ref6.name,
            pillValue = _ref6.pillValue;
        return (0, _preact.h)("div", {
          key: filter
        }, (0, _preact.h)(_Pill.default, {
          newStyle: true
        }, (0, _preact.h)("div", {
          className: "truncated",
          onClick: function onClick() {
            return _this3.setState({
              areFiltersOpen: false,
              areFiltersOpenFromFilterPill: !areFiltersOpenFromFilterPill,
              areFiltersOpenFromMain: false,
              selectedFilter: filter
            }, _this3.addHandler);
          }
        }, (0, _preact.h)("span", {
          className: "filter-type"
        }, name), (0, _preact.h)("span", {
          className: "filter-value"
        }, pillValue)), (0, _preact.h)(_assets.default, {
          customClass: "filter-pill-dismiss qa-dismiss-".concat(filter, "-filter-pill"),
          icon: "close",
          width: 16,
          height: 16,
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return onFilterChange(filter, null);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))
        })), areFiltersOpenFromFilterPill && selectedFilter === filter && (0, _preact.h)("div", {
          className: "overview__filters-box-container"
        }, (0, _preact.h)("div", {
          className: "overview__filters-box"
        }, _this3.getFiltersMenu())));
      }), (0, _preact.h)(_Button.default, {
        outlined: true,
        size: "medium",
        className: "qa-overview-clear-filters",
        title: clearFiltersLabel,
        variant: "danger",
        onClick: this.onClearFilterCriteria,
        "data-track-type": dataTrackType,
        "data-element-name": dataElementName ? "".concat(dataElementName, " clear filter button") : undefined
      }), (0, _preact.h)(_Button.default, {
        outlined: true,
        size: "medium",
        className: "qa-overview-hide-filters",
        title: hideBtnLabel,
        variant: "secondary-reversed",
        onClick: this.toggleAppliedFiltersVisibility,
        "data-track-type": dataTrackType,
        "data-element-name": dataElementName ? "".concat(dataElementName, " hide filter button") : undefined
      })));
    }
  }]);
  return OverviewFilters;
}(_preact.Component);

var _default = OverviewFilters;
exports.default = _default;